/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Withdrawal_DescriptionInputs */

const en_legal_withdrawal_description = /** @type {(inputs: Legal_Withdrawal_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your 14-day right to withdraw, with a form you can use.`)
};

const pl_legal_withdrawal_description = /** @type {(inputs: Legal_Withdrawal_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twoje 14-dniowe prawo odstąpienia od umowy, z formularzem, z którego możesz skorzystać.`)
};

/**
* | output |
* | --- |
* | "Your 14-day right to withdraw, with a form you can use." |
*
* @param {Legal_Withdrawal_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const legal_withdrawal_description = /** @type {((inputs?: Legal_Withdrawal_DescriptionInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Withdrawal_DescriptionInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_legal_withdrawal_description(inputs)
	return en_legal_withdrawal_description(inputs)
});